import { pathOr, always, equals, toLower, cond, T, isEmpty, } from 'ramda';
import { LoanContext } from 'src/types';

import {
  STATUS_STARTED,
  LOAN_START_REASON,
  LOAN_START_REASON_INVITE_LINK,

} from 'src/services/constants/activites';
import { isNotEmpty, returnIsNotEmptyOrTrue } from "src/utilities/hasValue";
import {
  getTheBorrowerRoleId,
  getTheCoBorrowerLoanAppRole,
  uniqueId,
} from 'src/utilities/borrowers';
import { IN_BRANCH_SIGNUP, LO_INVITE_LINK } from "src/features/constants";
import { getAccountId } from 'src/services/objects/finder';
import { isExistingInBranchCustomer, isNewInBranchCustomer } from 'src/utilities/storage';

/**
 * mkLoanContext
 *
 * Make a loan context from the response of a created loan
 *
 * @param loanResponse { object } The loan response received upon creation
 **
 */
export const mkLoanContext = (data: any, accountEmail: any): LoanContext => {
  const loanAppId = pathOr('', ['id'], data);
  const loanRoleIds = [getTheBorrowerRoleId(data)];
  const loanRoleAccountId = getAccountId(data);
  const teamId = pathOr('', ['spec', 'teams', 'id'], data);
  const loanType = pathOr('', ['type_of_loan'], data);
  const loanProductType = pathOr('', ['sub_type_of_loan'], data);

  return {
    loanAppId,
    loanType,
    loanProductType,
    loanRoleIds,
    teamId,
    loanRoleAccountId,
    accountEmail,
  };
};

export const mkCoLoanContext = (data: any, accountEmail: any): LoanContext => {
  const loanAppId = uniqueId(data);
  //TO-DO: What is the design decision to use loanRoleIds in an array?
  const loanRole = getTheCoBorrowerLoanAppRole(data)
  const loanRoleIds = [uniqueId(loanRole)];
  const loanRoleAccountId = getAccountId(loanRole);
  const teamId = pathOr('', ['spec', 'teams', 'id'], data);
  const loanType = pathOr('', ['type_of_loan'], data);
  const loanProductType = pathOr('', ['sub_type_of_loan'], data);

  const currentLoanRoleContext = {
    loanAppId,
    loanType,
    loanProductType,
    loanRoleIds,
    teamId,
    loanRoleAccountId,
    accountEmail,
    hasCurrentContext: true
  }
  return currentLoanRoleContext;
};


export const initLoanAuditEvent = (
  loanContext: any,
  createdBy: any,
  onCreateAudit: any,
  signupType: any,
  advisorUsername: string,
  campaign: string
) => {
  const advUsername = advisorUsername;
  const startedBy = equals(signupType, LO_INVITE_LINK) ?
    `(apply/${advisorUsername})` : isNotEmpty(advUsername) ? `(${advUsername})` : '';

  const inBranch = returnIsNotEmptyOrTrue(
    isNewInBranchCustomer(),
    'new',
    returnIsNotEmptyOrTrue(
      isExistingInBranchCustomer(),
      'existing',
      ''
    )
  )

  const { loanAppId } = loanContext;

  const reason = cond([
    [() => isNotEmpty(campaign), always(`${LOAN_START_REASON_INVITE_LINK} the ${campaign}`)],
    [() => isNotEmpty(advUsername) && isEmpty(campaign), always(`${LOAN_START_REASON_INVITE_LINK} invite link`)],
    [() => isNotEmpty(signupType) && equals(signupType, IN_BRANCH_SIGNUP), always(`${LOAN_START_REASON_INVITE_LINK} in branch ${inBranch}`)],
    [T, always(LOAN_START_REASON)],
  ])();
  onCreateAudit(
    loanAppId,
    `${createdBy}`,
    toLower(STATUS_STARTED),
    reason,
    startedBy
  );
};
